<div class="modal-container">
  <div id="finalizacionModal" class="ui tiny modal">
      <div class="header">Confirmar acción</div>
      <div class="content">
          <p class="pregunta">¿Estás seguro de que deseas finalizar esta misión? Esta acción no se puede deshacer.</p>
      </div>
      <div class="actions">
          <div class="ui cancel button">Cancelar</div>
          <div class="ui button primary" (click)="confirmarFinalizar()">Sí, finalizar</div>
      </div>
  </div>
</div>

<div class="ui grid">
    <div class="six  wide column score-header">
        <h3 class='title-style' style="margin:12px 0px 15px 0px!important;color:gray; font-size: 1.5em; ">{{title}} </h3>
        
        <h2 *ngIf="!esComplete" class='negrita ' style="margin-left: 0px!important;">
            Estado:<span class='font-gray' style='margin-top: 0px!important;padding-left: 5px;'>{{estado}}</span></h2>
        <h2 *ngIf="!esComplete" class='negrita ' style='margin:12px 0px 15px 0px!important;'>
            Funcionalidad: 
            <span *ngIf="score>= 0" class='font-gray' style='margin-top: 0px!important;padding-left: 5px;'>{{score}}</span>
            <span *ngIf="score < 0" class='font-gray' style='margin-top: 0px!important;padding-left: 5px;'>N/A</span>
        </h2>

    </div>
    <div class="ten wide column right aligned   score-header no-pdf">
        <h2 *ngIf="esComplete" class='font-gray'
            style='font-size:18px;margin : 12px 0px 15px 0px!important;'>
            Funcionalidad: 
          <span *ngIf="score>=0" class='font-gray' style='margin-top: 0px!important;padding-left: 5px;'>{{score}}</span>
            <span *ngIf="score<0" class='font-gray' style='margin-top: 0px!important;padding-left: 5px;'>N/A</span>
        </h2>





        <ng-container *ngIf="!esComplete">
            <div class="ui dropdown manu-dropdown button primary"
                style="font-weight:bold; padding:17.5px 17.5px 17.5px 1px; height: min-content;">

                Opciones
                <i class="dropdown icon"></i>
                <div class="menu">


                    <div role="link" class="item" (click)="descargarPDF()">
                        <span class="">
                            <i class="download icon pointer"></i>
                            DESCARGAR PDF

                        </span>
                    </div>

                    <div role="link" class="item" (click)="copyURL()">
                        <span class="">
                            <i class="clone outline pointer
                icon"></i>
                            COPIAR LINK

                        </span>
                    </div>



                    <div role="link" class="item" (click)="descargarLogs()">
                        <span class="">
                            <i class="download icon pointer"></i>
                            DESCARGAR LOGS
                        </span>
                    </div>
                    <div  *ngIf="botonFinalizar && (estado=='Completo')" role="link" class="item" (click)="finalizar()">
                        <span class="">
                            <i class="check icon pointer"></i>
                           FINALIZAR
                        </span>
                    </div>

                   
                </div>
            </div>
        </ng-container>

    </div>



</div>

<div class="ui divider no-pdf-flex"></div>